import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Badge, Button, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { T } from '../../i18n';
import AddIcon from '@mui/icons-material/Add';


const RentalItem = ({items, item, index, readonly, days, onAdd, onRemove, catalogue, checkoutMode}:any) => {
    const numberOfItems = items.filter((i: any) => i.id === item.id).length
    let itemPrice = numberOfItems * item.price
    if(item.pricePerDay) {
        itemPrice = itemPrice * days
    }
    if(checkoutMode && numberOfItems === 0) {
        return <></>
    }
    return (
        <>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Badge badgeContent={numberOfItems} color='primary' >
                        <Avatar src={item.typeIcon} />
                    </Badge>
                </ListItemAvatar>
                <ListItemText
                style={{width: '200px'}}
                    primary={`${item.name} (${item.price * (item.pricePerDay ? days: 1)}€)`}
                    secondary={
                        <React.Fragment>
                        <Typography
                            variant="body2"
                        >
                            {item.description}
                        </Typography>
                        {/* {item.confirmationRequired &&
                            <b>
                                <small style={{color: '#c05b0c'}}>{"Riceverai email per confermare la disponibilità"}</small>
                            </b>
                        } */}
                        </React.Fragment>
                    }
                />
                {readonly ? (
                   <> {checkoutMode ? 
                        <span>{item.pricePerDay ? `${item.price}€ x ${numberOfItems} x ${days} ${T('day_plurar', {plural: days === 1 ? T('o') : T('i')})} = ` : `${item.price}€ x ${numberOfItems} = `}&nbsp;<b>{`${itemPrice}€`}</b></span>:
                        <>{`${item.price * days}€`}</>
                    }
                    </>
                ):
                (
                    <div className='add-remove-btns'>
                        <IconButton onClick={() => onRemove(item)} color={numberOfItems > 0 ? 'error': 'default'}>
                            <Remove/>
                        </IconButton>
                        <Typography>{numberOfItems}</Typography>
                        <IconButton onClick={() => onAdd(item)} color='primary'>
                            <AddIcon/>
                        </IconButton>
                    </div>
                )}
            </ListItem>
            {index < catalogue.length - 1 &&
                <Divider variant="inset" component="li" />
            }
        </>
    )
}

export const RentalDetails = ({ catalogue, readonly, days, items, checkoutMode, onAdd, onRemove, extraClass }: any) => {
    return (
        <div className={`rental-detail ${extraClass ? extraClass : ''}`}>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {catalogue.map((item:any, index:  number) => {
                    return (
                        <RentalItem items={items} item={item} index={index} onAdd={onAdd} onRemove={onRemove} catalogue={catalogue} readonly={readonly} days={days} checkoutMode={checkoutMode}/>
                    );
                })}
            </List>
        </div>
    );
}